import {
	APP_INIT,
	APP_SHOW_ALERT,
	APP_HIDE_ALERT,
	APP_SET_SESSION_ID,
	APP_CACHE_FILTERS,
	APP_SEARCH_SET,
	APP_SEARCH_CLEAR,
	APP_SORT_LIST,
	APP_SORT_LOADING,
	APP_PAGE_TITLE,
	APP_POST_RATING,
	APP_POST_RATING_LOADING,
	APP_POST_RATING_ERROR,
	APP_OTHER_PROFILE_ACCESS
} from './types'

import { getSortList } from '@/api/list'
import { postRatings } from '@/api/feedback'

const postRating = async (ctx, { rating_entity_type, rating_entity_id, rating }) => {
	try {
		ctx.commit(APP_POST_RATING_LOADING, true)
		const { data } = await postRatings({ rating_entity_type, rating_entity_id, rating })
		ctx.commit(APP_POST_RATING, data)
	} catch (e) {
		ctx.commit(APP_POST_RATING_ERROR, e)
	} finally {
		ctx.commit(APP_POST_RATING_LOADING, false)
	}
}

const setPageTitle = async (ctx, payload) => {
	try {
		ctx.commit(APP_PAGE_TITLE, payload)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const getSort = async (ctx, { name, sources }) => {
	try {
		ctx.commit(APP_SORT_LOADING, true)
		const { data } = await getSortList(name, sources)
		ctx.commit(APP_SORT_LIST, { data, name })
	} catch (e) {
		console.error(e)
	} finally {
		ctx.commit(APP_SORT_LOADING, false)
	}
}

const init = async (ctx) => {
	try {
		ctx.commit(APP_INIT)
	} catch (e) {
		console.log(e)
	}
}

const showAlert = async (ctx, payload) => {
	try {
		ctx.commit(APP_SHOW_ALERT, payload)
	} catch (e) {
		console.log(e)
	}
}

const hideAlert = async (ctx, message = '') => {
	try {
		ctx.commit(APP_HIDE_ALERT, message)
	} catch (e) {
		console.log(e)
	}
}

const setSessionId = async (ctx, id) => {
	try {
		ctx.commit(APP_SET_SESSION_ID, id)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const cachePageFilters = async (ctx, payload) => {
	try {
		ctx.commit(APP_CACHE_FILTERS, payload)
	} catch (e) {
		console.error(e)
		throw e
	}
}

const setSearch = async (ctx, payload) => {
	try {
		ctx.commit(APP_SEARCH_SET, payload)
	} catch (e) {
		console.log(e)
		throw e
	}
}

const clearSearch = async (ctx) => {
	try {
		ctx.commit(APP_SEARCH_CLEAR)
	} catch (e) {
		console.log(e)
		throw e
	}
}

const setOtherProfileAccess = async (ctx, payload) => {
	try{
		ctx.commit(APP_OTHER_PROFILE_ACCESS, payload)
	} catch (e) {
		console.log(e)
	}
}

export default {
	init,
	showAlert,
	hideAlert,
	setSessionId,
	cachePageFilters,
	setSearch,
	clearSearch,
	getSort,
	setPageTitle,
	postRating,
	setOtherProfileAccess
}
